module.exports = __webpack_public_path__ + "static/media/Google.38aabe06.png";